// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "Image-module--arrow-up-and-down--10147";
export var image = "Image-module--image--3aa31";